import React from 'react';

import BookOnlineIcon from '@mui/icons-material/BookOnline';
import { Chip, Tooltip } from '@mui/material';

interface Props {
  accommV2Bookable?: boolean;
  /** `icon` for dense contexts such as grid cells; `chip` for page headers. */
  variant?: 'icon' | 'chip';
}

const ACCOMM_V2_BOOKABLE_TOOLTIP =
  'Accommodation V2 booking is enabled: this property may book via the accommodationV2 checkout path.';

export default function AccommodationV2BookableChip({ accommV2Bookable, variant = 'chip' }: Props) {
  if (!accommV2Bookable) {
    return null;
  }

  return (
    <Tooltip title={ACCOMM_V2_BOOKABLE_TOOLTIP}>
      {variant === 'icon' ? (
        <BookOnlineIcon color="success" fontSize="small" aria-label="Accommodation V2 booking enabled" />
      ) : (
        <Chip icon={<BookOnlineIcon />} label="Accom V2 booking" size="small" color="success" variant="outlined" />
      )}
    </Tooltip>
  );
}
